var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-1 p-0 pl-3" },
        [_c("b-avatar", { attrs: { size: "lg", src: _vm.currentAvatar } })],
        1
      ),
      _c("div", { staticClass: "col-8 p-0" }, [
        _c(
          "div",
          { staticClass: "form-label-group mt-1" },
          [
            _c(
              "Mentionable",
              {
                attrs: { keys: ["@"], items: _vm.items },
                on: {
                  search: function($event) {
                    return _vm.getUsers($event)
                  },
                  apply: function($event) {
                    return _vm.applyUser($event)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-result",
                    fn: function() {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.loading ? "Buscando..." : "Sin coincidencias."
                            ) +
                            " "
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c("b-form-textarea", {
                  staticClass: "w-100",
                  attrs: {
                    placeholder:
                      "Agrega un comentario público y usa @ para mencionar a alguien",
                    value: _vm.newComment,
                    id: "comment",
                    "data-cy": "write-comment",
                    rows: "5"
                  },
                  on: {
                    input: function($event) {
                      _vm.newComment = $event
                    }
                  }
                })
              ],
              1
            ),
            _c("label", { attrs: { for: "label-comment" } }, [
              _vm._v("Agrega un comentario público:")
            ])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-3 p-2 mt-1" },
        [
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED087",
                  expression: "'ED087'"
                }
              ],
              staticClass: "text-sm p-2 mb-1 w-100",
              attrs: {
                variant: "primary",
                disabled: _vm.disabledComment || _vm.processingSave,
                "data-cy": "comment"
              },
              on: { click: _vm.addComment }
            },
            [
              _vm._v(" Comentar "),
              _c("span", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.processingSave,
                    expression: "processingSave"
                  }
                ],
                staticClass: "spinner-border spinner-border-sm text-white"
              })
            ]
          ),
          _c(
            "b-button",
            {
              staticClass: "text-sm p-2 w-100",
              attrs: {
                variant: "outline-danger",
                disabled: _vm.disabledComment || _vm.processingSave,
                "data-cy": "cancel"
              },
              on: {
                click: function($event) {
                  _vm.newComment = ""
                }
              }
            },
            [_vm._v(" Cancelar ")]
          )
        ],
        1
      )
    ]),
    _c("hr"),
    !_vm.commentsStack.length && _vm.loading === false
      ? _c("div", [
          _c("h5", { staticClass: "mt-3 text-center" }, [
            _vm._v("No hay comentarios para este elemento")
          ])
        ])
      : _c(
          "div",
          { staticClass: "row justify-content-center" },
          [
            _c(
              "app-timeline",
              { staticClass: "col-12 col-lg-8" },
              _vm._l(_vm.commentsStack, function(comment, index) {
                return _c(
                  "app-timeline-item",
                  { key: "comment_" + index, attrs: { variant: "info" } },
                  [
                    _c(
                      "b-media",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.loading,
                            expression: "!loading"
                          }
                        ],
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "aside",
                              fn: function() {
                                return [
                                  _c("b-avatar", {
                                    attrs: { src: comment.avatar }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-sm-row flex-column\n              flex-wrap justify-content-between mb-1 mb-sm-0"
                          },
                          [
                            _c("h6", [_vm._v(_vm._s(comment.usuario.alias))]),
                            _c(
                              "div",
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-xs pr-3 text-secondary"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm
                                            .$moment(
                                              comment.fecha,
                                              "YYYY-MM-DD HH:mm:ss"
                                            )
                                            .format("LLLL")
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                comment.usuario.id === _vm.currentUser.id
                                  ? _c("feather-icon", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Editar",
                                          expression: "'Editar'"
                                        }
                                      ],
                                      staticClass:
                                        "text-success cursor-pointer mr-2",
                                      attrs: { icon: "EditIcon", size: "16" },
                                      on: {
                                        click: function($event) {
                                          return _vm.editComment(index)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                comment.usuario.id === _vm.currentUser.id
                                  ? _c("feather-icon", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Eliminar",
                                          expression: "'Eliminar'"
                                        }
                                      ],
                                      staticClass: "text-danger cursor-pointer",
                                      attrs: {
                                        icon: "Trash2Icon",
                                        size: "16",
                                        disabled: _vm.processingDelete
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteComment(index)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _vm.editingCommentIndex === index
                          ? _c("div", [
                              _c("div", { staticClass: "row mt-4" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-label-group mt-1" },
                                    [
                                      _c(
                                        "Mentionable",
                                        {
                                          attrs: {
                                            keys: ["@"],
                                            items: _vm.items
                                          },
                                          on: {
                                            search: function($event) {
                                              return _vm.getUsers($event)
                                            },
                                            apply: function($event) {
                                              return _vm.applyUser($event)
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "no-result",
                                                fn: function() {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.loading
                                                            ? "Buscando..."
                                                            : "Sin coincidencias :("
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            staticClass: "w-100 mb-3",
                                            attrs: {
                                              placeholder:
                                                "Agrega un comentario público...",
                                              id: "edit-comment-" + index,
                                              rows: "5"
                                            },
                                            model: {
                                              value: _vm.editingComment,
                                              callback: function($$v) {
                                                _vm.editingComment = $$v
                                              },
                                              expression: "editingComment"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "label",
                                        {
                                          attrs: {
                                            for: "edit-comment-" + index
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " Agrega un comentario público: "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "col-12" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "text-sm p-2 w-32 mr-2",
                                        attrs: {
                                          variant: "primary",
                                          disabled:
                                            !_vm.editingComment.length ||
                                            _vm.processingUpdate
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.updateComment(index)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(" Guardar "),
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.processingUpdate,
                                              expression: "processingUpdate"
                                            }
                                          ],
                                          staticClass:
                                            "spinner-border spinner-border-sm text-white"
                                        })
                                      ]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "text-sm p-2 w-32",
                                        attrs: {
                                          variant: "outline-danger",
                                          disabled:
                                            !_vm.editingComment.length ||
                                            _vm.processingUpdate
                                        },
                                        on: { click: _vm.resetEditForm }
                                      },
                                      [_vm._v(" Cancelar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ])
                          : _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formatComment(comment.comentario)
                                )
                              }
                            })
                      ]
                    ),
                    _c(
                      "b-media",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "aside",
                              fn: function() {
                                return [
                                  _c("b-skeleton", {
                                    attrs: { type: "avatar", animation: "fade" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-sm-row flex-column\n              flex-wrap justify-content-between mb-1 mb-sm-0"
                          },
                          [
                            _c("b-skeleton", { staticClass: "w-64" }),
                            _c("b-skeleton", { staticClass: "w-16" })
                          ],
                          1
                        ),
                        _c("p", [_c("b-skeleton", { staticClass: "w-64" })], 1)
                      ]
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        ),
    _vm.loading
      ? _c("div", [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-1" },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", type: "avatar" }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-9" },
              [
                _c("b-skeleton", {
                  attrs: { animation: "fade", type: "input" }
                })
              ],
              1
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }